import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as settingsSelectors from '../../Mars/Settings/settings.selectors'

import MiningChangePhasePopup from '../../Mars/Mining/MiningChangePhasePopup/MiningChangePhasePopup'

import * as tutorialActions from '../tutorial.actions'

const mapDispatchToProps = (dispatch) => ({
  // no need to mock, can be deleted if it will not make errors ;)
  syncWithSettings: () => console.log('sync with settings'),
  setMineDisclaimer: () => console.log('set Mine disclaimer'),

  // mocked
  nextPhase: bindActionCreators(tutorialActions.nextPhase, dispatch),
  removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
})

const mapStateToProps = (state) => ({
  settings: settingsSelectors.getSettings(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MiningChangePhasePopup))
